import axios from ".";

export const createCRMPlan = (data: any) => {
  return axios({
    method: "POST",
    url: `/plans`,
    data,
  });
};

export const updateCRMPlan = (
  planId: number,
  section: "basicDetails" | "pricing" | "benefits",
  data: any
) => {
  return axios({
    method: "PUT",
    url: `/plans/${planId}/update/${section}`,
    data,
  });
};

export const toggleCRMPlanStatus = (planId: any, data: any) => {
  return axios({
    method: "PUT",
    url: `/plans/status/${planId}`,
    data,
  });
};

export const archiveCustomCRMPlan = (planId: any) => {
  return axios({
    method: "DELETE",
    url: `/plans/custom-plan/${planId}`,
  });
};

export const assignCustomPlantoPartners = (data: any, planId: number) => {
  return axios({
    method: "PUT",
    url: `/plans/custom-plan/${planId}/assign`,
    data,
  });
};